import { default as emailsErBSrADnTAMeta } from "/app/pages/auth/emails.vue?macro=true";
import { default as indexaVPDnhf1OvMeta } from "/app/pages/auth/index.vue?macro=true";
import { default as loginikXFF2hTKwMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as logoutCHyXH6UWwkMeta } from "/app/pages/auth/logout.vue?macro=true";
import { default as passwordJ5Qbit1XVXMeta } from "/app/pages/auth/password.vue?macro=true";
import { default as confirmezsXPRItVjMeta } from "/app/pages/auth/reminder/confirm.vue?macro=true";
import { default as indexg7PiFiH7MkMeta } from "/app/pages/auth/reminder/index.vue?macro=true";
import { default as signupHJ1GDnyyMkMeta } from "/app/pages/auth/signup.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
export default [
  {
    name: "auth__emails",
    path: "/auth/emails",
    meta: emailsErBSrADnTAMeta || {},
    component: () => import("/app/pages/auth/emails.vue").then(m => m.default || m)
  },
  {
    name: "auth__index",
    path: "/auth",
    meta: indexaVPDnhf1OvMeta || {},
    component: () => import("/app/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: "auth__login",
    path: "/auth/login",
    meta: loginikXFF2hTKwMeta || {},
    component: () => import("/app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: "auth__logout",
    path: "/auth/logout",
    meta: logoutCHyXH6UWwkMeta || {},
    component: () => import("/app/pages/auth/logout.vue").then(m => m.default || m)
  },
  {
    name: "auth__password",
    path: "/auth/password",
    meta: passwordJ5Qbit1XVXMeta || {},
    component: () => import("/app/pages/auth/password.vue").then(m => m.default || m)
  },
  {
    name: "auth__reminder__confirm",
    path: "/auth/reminder/confirm",
    meta: confirmezsXPRItVjMeta || {},
    component: () => import("/app/pages/auth/reminder/confirm.vue").then(m => m.default || m)
  },
  {
    name: "auth__reminder",
    path: "/auth/reminder",
    meta: indexg7PiFiH7MkMeta || {},
    component: () => import("/app/pages/auth/reminder/index.vue").then(m => m.default || m)
  },
  {
    name: "auth__signup",
    path: "/auth/signup",
    meta: signupHJ1GDnyyMkMeta || {},
    component: () => import("/app/pages/auth/signup.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  }
]